<template>
    <div>
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{trans('configuration.configuration')}}</h3>
                    <div class="nk-block-des text-soft">
                        <p>{{ trans('permission.permission') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="admin-config-layout admin-linear-page">
            <configuration-sidebar menu="permission"></configuration-sidebar>
            <div class="admin-config-panel">
                <div class="admin-config-panel__inner admin-config-panel__inner--wide">
                    <div class="admin-linear-head">
                        <div>
                            <span class="admin-linear-head__eyebrow">Security matrix</span>
                            <h4 class="admin-linear-head__title">{{ trans('permission.permission') }}</h4>
                            <p class="admin-linear-head__description">Maintain atomic capabilities and jump into the role assignment matrix when access needs to change.</p>
                        </div>
                        <div class="admin-linear-stat" role="status">
                            <span>{{ trans('permission.permission_list') }}</span>
                            <strong>{{ permissions && permissions.total ? permissions.total : 0 }}</strong>
                        </div>
                    </div>
                    <show-tip module="permission" tip="tip_permission"></show-tip>

                    <section class="admin-config-list-section" aria-labelledby="admin-config-permission-list-title">
                        <header class="admin-config-list-head admin-config-list-head--split">
                            <div class="admin-config-list-head__text">
                                <h4 id="admin-config-permission-list-title" class="admin-config-list-head__title">
                                    {{trans('permission.permission_list')}}
                                </h4>
                                <p
                                    v-if="permissions && permissions.total"
                                    class="admin-config-list-head__sub"
                                    role="status"
                                >
                                    {{trans('general.total_result_found',{'count' : permissions.total})}}
                                </p>
                                <p
                                    v-else-if="permissions"
                                    class="admin-config-list-head__sub admin-config-list-head__sub--empty"
                                    role="status"
                                >
                                    {{trans('general.no_result_found')}}
                                </p>
                            </div>
                            <div class="admin-config-list-head__actions">
                                <router-link
                                    to="/configuration/permission/assign"
                                    class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline"
                                >
                                    {{trans('permission.assign_permission')}}
                                </router-link>
                                <button
                                    type="button"
                                    class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid"
                                    v-b-modal.modal-permission-create
                                >
                                    <admin-icon name="plus"></admin-icon> {{ trans('general.add_new') }}
                                </button>
                            </div>
                        </header>

                        <div class="admin-list-table-card admin-config-list-card" v-if="permissions && permissions.total">
                            <div class="table-responsive">
                                <table class="table admin-data-table admin-data-table--config-list admin-linear-table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">{{trans('permission.name')}}</th>
                                            <th scope="col" class="admin-table-actions-cell">{{trans('general.action')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="permission in permissions.data" :key="permission.id">
                                            <td>
                                                <strong class="admin-linear-primary">{{ toWord(permission.name) }}</strong>
                                                <span class="admin-linear-muted">{{ permission.name }}</span>
                                            </td>
                                            <td class="admin-table-actions-cell">
                                                <table-row-action-dropdown>
                                                    <b-dropdown-item-button
                                                        v-confirm="{ok: confirmDelete(permission)}"
                                                        class="admin-row-actions__danger"
                                                    >
                                                        <admin-icon name="trash"></admin-icon> {{ trans('permission.delete_permission') }}
                                                    </b-dropdown-item-button>
                                                </table-row-action-dropdown>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="admin-table-pagination-wrap">
                                <pagination-record
                                    :page-length.sync="filterPermissionForm.page_length"
                                    :records="permissions"
                                    @updateRecords="getPermissions"
                                    @change.native="getPermissions"
                                ></pagination-record>
                            </div>
                        </div>
                        <module-info
                            v-if="permissions && !permissions.total"
                            module="permission"
                            title="module_info_title"
                            description="module_info_description"
                            icon="key"
                        ></module-info>
                    </section>
                </div>
            </div>
        </div>

        <b-modal
            id="modal-permission-create"
            hide-footer
            centered
            lazy
            modal-class="admin-modal-pro"
            content-class="admin-modal-pro__content"
        >
            <template #modal-title>{{trans('permission.add_new_permission')}}</template>
            <permission-form @completed="getPermissions" @cancel="$bvModal.hide('modal-permission-create')"></permission-form>
        </b-modal>
    </div>
</template>


<script>
    import configurationSidebar from '../system-config-sidebar'
    import permissionForm from './form'

    export default {
        components : { configurationSidebar,permissionForm },
        data() {
            return {
                permissions: {
                    total: 0,
                    data: []
                },
                filterPermissionForm: {
                    page_length: helper.getConfig('page_length')
                }
            };
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }
            this.getPermissions();
        },
        methods: {
            getPermissions(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                this.$bvModal.hide('modal-permission-create');
                let url = helper.getFilterURL(this.filterPermissionForm);
                axios.get('/api/permission?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.permissions = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            confirmDelete(permission){
                return dialog => this.deletePermission(permission);
            },
            deletePermission(permission){
                axios.delete('/api/permission/'+permission.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getPermissions();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            toWord(str){
                return helper.toWord(str);
            }
        }
    }
</script>

<style scoped>
.admin-linear-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1.25rem;
    margin-bottom: 1.25rem;
    padding: 1.1rem 1.2rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.06), var(--dash-pro-surface));
}

.admin-linear-head__eyebrow {
    display: block;
    color: var(--lms-primary);
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.admin-linear-head__title {
    margin: 0.35rem 0 0;
    color: var(--dash-pro-text);
    font-size: 1.35rem;
    font-weight: 700;
    letter-spacing: -0.04em;
}

.admin-linear-head__description {
    max-width: 42rem;
    margin: 0.45rem 0 0;
    color: var(--dash-pro-muted);
    font-size: 0.875rem;
    line-height: 1.55;
}

.admin-linear-stat {
    min-width: 8.5rem;
    padding: 0.85rem 1rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: var(--dash-pro-surface);
    text-align: right;
}

.admin-linear-stat span {
    display: block;
    color: var(--dash-pro-muted);
    font-size: 0.72rem;
    font-weight: 700;
}

.admin-linear-stat strong {
    display: block;
    margin-top: 0.25rem;
    color: var(--dash-pro-text);
    font-size: 1.65rem;
    letter-spacing: -0.06em;
}

.admin-linear-primary {
    display: block;
    color: var(--dash-pro-text);
    font-weight: 650;
}

.admin-linear-muted {
    display: block;
    margin-top: 0.2rem;
    color: var(--dash-pro-muted);
    font-size: 0.75rem;
}

@media (max-width: 767.98px) {
    .admin-linear-head {
        align-items: stretch;
        flex-direction: column;
    }

    .admin-linear-stat {
        text-align: left;
    }
}
</style>
